// Generated by CoffeeScript 1.11.1
(function() {
  var Descriptor, LayerInfo, VectorStroke,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  Descriptor = require('../descriptor');

  module.exports = VectorStroke = (function(superClass) {
    extend(VectorStroke, superClass);

    function VectorStroke() {
      return VectorStroke.__super__.constructor.apply(this, arguments);
    }

    VectorStroke.shouldParse = function(key) {
      return key === 'vstk';
    };

    VectorStroke.prototype.parse = function() {
      this.file.seek(4, true);
      return this.data = new Descriptor(this.file).parse();
    };

    return VectorStroke;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/vector_stroke.js
// module id = 80
// module chunks = 0